import Title from 'components/Title'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import InputLabel from 'ui/InputLabel'
import Separator from 'ui/Separator'
import {
  instrumentFieldIsDefined,
  instrumentHasData,
} from 'utils/functions/transactions'
import theme from 'utils/theme'
import { CreateTransactionFormValues } from 'utils/types/updateForm'
import UpdateText from 'containers/UpdatesV2/ShowUpdateContent/UpdateText'
import {
  Content,
  Row,
  TransactionContent,
} from '../ShowTransactionContent.styles'

const EquityInstrumentContent = ({
  transaction,
}: {
  transaction: CreateTransactionFormValues
}) => {
  if (
    !instrumentFieldIsDefined(transaction.description) &&
    !instrumentHasData(transaction.instrument!, transaction)
  ) {
    return null
  }
  return (
    <TransactionContent>
      <Row gridColumn="1 / 3">
        <Title
          title={<FormattedMessage id="transactions.additionalInformation" />}
          color={theme.colors.lightGray}
        />
        <Separator />
      </Row>

      {instrumentFieldIsDefined(transaction.description) && (
        <Row gridColumn="1 / 3">
          <InputLabel marginLeft="1.4rem">
            <FormattedMessage id="updates.description" />
          </InputLabel>
          <Content>
            <UpdateText text={transaction.description} />
          </Content>
        </Row>
      )}

      {instrumentFieldIsDefined(transaction?.purchasePricePerShare) && (
        <Row>
          <InputLabel marginLeft="1.4rem">
            <FormattedMessage id="transactions.purchasePricePerShare" />
          </InputLabel>
          <Content>
            $
            <FormattedNumber
              value={transaction.purchasePricePerShare!}
              maximumFractionDigits={6}
            />
          </Content>
        </Row>
      )}

      {instrumentFieldIsDefined(transaction?.sharesPurchased) && (
        <Row>
          <InputLabel marginLeft="1.4rem">
            <FormattedMessage id="transactions.sharesPurchased" />
          </InputLabel>
          <Content capitalize>{transaction.sharesPurchased}</Content>
        </Row>
      )}

      {instrumentFieldIsDefined(transaction?.preMoneyValuation) && (
        <Row>
          <InputLabel marginLeft="1.4rem">
            <FormattedMessage id="transactions.preMoneyValuation" />
          </InputLabel>
          <Content>
            $
            <FormattedNumber
              value={transaction.preMoneyValuation!}
              maximumFractionDigits={2}
            />
          </Content>
        </Row>
      )}

      {instrumentFieldIsDefined(transaction?.postMoneyValuation) && (
        <Row>
          <InputLabel marginLeft="1.4rem">
            <FormattedMessage id="transactions.postMoneyValuation" />
          </InputLabel>
          <Content>
            $
            <FormattedNumber
              value={transaction.postMoneyValuation!}
              maximumFractionDigits={2}
            />
          </Content>
        </Row>
      )}
    </TransactionContent>
  )
}

export default EquityInstrumentContent
